import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { entityStateZodSchema } from "@@/shared/entity-status";
import type {
    ChannexLogId} from "@@/shared/providers/integrations/channex/channex-log-id";
import {
    channexLogIdFactory,
    channexLogIdZodSchema,
} from "@@/shared/providers/integrations/channex/channex-log-id";
import { addDays } from "date-fns";
import type { Except } from "type-fest";
import { z } from "zod";

const channexApiLogZodObject = z.object({
    _id: channexLogIdZodSchema,
    _type: z.literal("CHANNEX_API_LOG"),
    _createdAt: isoAndUnixZodSchema,
    _status: entityStateZodSchema,

    apiEndpoint: z.string(),

    apiRequest: z.record(z.any()).optional(),
    apiResponse: z.record(z.any()).optional(),

    deleteAfter: z.date().optional(),
});

type ChannexApiLog = z.infer<typeof channexApiLogZodObject>;

type MappingFactoryParams = Except<
    ChannexApiLog,
    "_id" | "_createdAt" | "_type" | "_status"
> & {
    _id?: ChannexLogId;
    _status?: ChannexApiLog["_status"];
};
const channexApiLogFactory = (input: MappingFactoryParams): ChannexApiLog => {
    return {
        ...input,
        _id: input._id ?? channexLogIdFactory(),
        _type: "CHANNEX_API_LOG",
        _createdAt: nowIsoAndUnix(),
        _status: input._status ?? "ACTIVE",
        deleteAfter: input.deleteAfter ?? addDays(new Date(), 14),
    };
};

export { channexApiLogFactory, channexApiLogZodObject };

export type { ChannexApiLog };
